import { PushpinFilled, SafetyCertificateOutlined } from "@ant-design/icons"
import { Period, PeriodReduced } from "../../location/hours/components/Period"

export const RegularDayScheduleView = (props: { title: any, regularHour:any, strike?: boolean }) => {

    return (
        <div style={{ display: "flex", justifyContent:'space-between'}}>
                <p style={{ width: "150px" , color:props.strike ? 'darkred' : 'slategrey', textAlign:'start'}} >
                    {props.strike && <PushpinFilled/>} {props.title} 
                </p>
                <div style={{display: "flex", flexDirection:'column', alignItems:'flex-end', marginTop:'10px'}}>
                    {
                        props.regularHour.length === 0
                            ? 
                                props.strike ? <del style={{color:'darkred'}}>Cerrado</del> : <b style={{color:'grey'}}>Cerrado</b>
                            : 
                            props.regularHour.map((data: any, i: any) => (
                                    <Period data={data} key={i} strike={props.strike}/> 
                                ))
                    }
                </div>
        </div>
    )
}

export const RegularDayScheduleViewSmall = (props: { title: any, regularHour:any }) => {

    return (
        <div style={{ display: "flex", justifyContent:'space-between'}}>
            {props.regularHour.length !== 0 && <div style={{ width: "100px" , color:'slategrey', textAlign:'end', margin:'0px'}} >
                {props.title}
            </div>}
            <span>
                {
                    props.regularHour.length !== 0 &&                        
                        props.regularHour.map((data: any, i: any) => (
                                <PeriodReduced data={data} key={i} />
                            ))
                }
            </span>
        </div>
    )
}
